import React from 'react';
import {
  ComboBoxParam,
  Form,
  HiddenParam,
  Option,
  RequiredHelpPhrase,
  Row,
  Select,
  SelectParam,
  SonForm,
  SubmitButton,
  useForm,
} from '../../../_lib/Form2';
import {
  ListBoxModifier,
  PersonPreview,
  UserComboBoxForForm2,
  useUserSingleSelectComboBox,
} from '../../../components/molecules/Form/components/ComboBox';
import { isNullOrUndefined } from '../../../lib/typeGuards';
import { useSonTranslation } from '../../../translation/useSonTranslation';

type ConnectedUsersAddFormProps = {
  form: SonForm<HiddenParam<'fromUserId'> | ComboBoxParam<'toUserId'> | SelectParam<'roleId'>>;
  onSuccess: () => void;
};

export function ConnectedUsersAddForm({ form, onSuccess }: ConnectedUsersAddFormProps) {
  const { t } = useSonTranslation('ConnectedUsers');

  const { formProps, params, fetchState } = useForm({ form, onSuccess });

  const hiddenParam = params.getByName('fromUserId');
  const toUserId = params.getByName('toUserId');
  const roleIdSelect = params.getByName('roleId');

  const { getComboBoxProps, selectedValue, clearSelection } = useUserSingleSelectComboBox({
    suggestUrl: toUserId.comboBoxUrl.url,
  });

  return (
    <Form id="connected-users-add-form" {...formProps}>
      <RequiredHelpPhrase />
      <input type="hidden" name={hiddenParam.name} value={hiddenParam.value} />
      <Row>
        <UserComboBoxForForm2
          labelTitle={t('addForm.input.userTo')}
          suggestUrl={toUserId.comboBoxUrl!.url}
          required={toUserId.required}
          modifierListBox={ListBoxModifier.RELATIVE}
          validationMessage={isNullOrUndefined(selectedValue) ? t('addForm.validationMessage.userTo') : ''}
          {...getComboBoxProps()}
        />
      </Row>
      {selectedValue && (
        <Row>
          <input type="hidden" value={selectedValue.id} name={toUserId.name} />
          <PersonPreview
            id={selectedValue.id}
            emailLink={selectedValue.emailLink}
            orgUnit={selectedValue.orgUnit}
            profileImageUrl={selectedValue.profileImageUrl}
            profileLink={selectedValue.pageLink}
            phoneLink={selectedValue.phoneLink}
            reset={clearSelection}
          />
        </Row>
      )}
      <Row>
        <Select label={t(`addForm.input.role`)} param={roleIdSelect}>
          {roleIdSelect.options.map(o => (
            <Option key={o.value} value={o.value}>
              {o.text}
            </Option>
          ))}
        </Select>
      </Row>
      <SubmitButton
        buttonLabel={t('addForm.submit')}
        messageSuccess={t('addForm.status.success')}
        messageSending={t('addForm.status.sending')}
        messageFail={t('addForm.status.fail')}
        customErrorTypeMessages={{ duplicateId: t('addForm.status.duplicateId') }}
        fetchState={fetchState}
      />
    </Form>
  );
}
